import readXlsxFile from "read-excel-file"
import writeXlsxFile from "write-excel-file"
import BaseApi from "../../../../api/api"
import { NotificationService } from "../../../../features/NotificationService/NotificationService"
import { SAMSON_RECODE_SCHEMA } from "../helpers/constant"

export type RecodeSamsonWbType = {
  article: number
  GoodCode: string
  nmId: number
  sku: string
  count: number
  sizes: string
  commission: number
}

export const parseSamsonRecode = async (
  file: File,
): Promise<RecodeSamsonWbType[]> => {
  const dataFromXslx = await readXlsxFile<RecodeSamsonWbType>(file, {
    schema: SAMSON_RECODE_SCHEMA.WB.JSON,
  })
  return dataFromXslx.rows
}

export const downloadSamsonRecode = async () => {
  try {
    const { success, items } = await BaseApi.getRecodeSamson()
    if (success) {
      writeXlsxFile(items, {
        schema: SAMSON_RECODE_SCHEMA.WB.EXCEL,
        fileName: "перекодировка самсон вб.xlsx",
      })
    } else {
      NotificationService.showNotification({
        level: "error",
        message: "Произошла ошибка",
      })
    }
  } catch (e) {}
}
